/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchTimeOffsRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {SearchTimeOffsResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const searchTimeOffs = (request: SearchTimeOffsRequest, options?: CashRequestOptions) => post<SearchTimeOffsRequest, SearchTimeOffsResponse>("/2.0/cash/search-time-offs", request, {...options, rejectOnError: true })